import Layout from '@/views/layout';

const WalletRouter = {
  path: '/wallet',
  meta: { title: '钱包' },
  component: Layout,
  redirect: { name: 'Wallet' },
  children: [
    {
      path: 'index',
      name: 'Wallet',
      component: () => import('@/views/wallet'),
      meta: { title: '钱包', noCache: true }
    },
    {
      path: 'withdraw',
      name: 'Withdraw',
      component: () => import('@/views/wallet/withdraw'),
      meta: { title: '申请提现', noCache: true }
    },
    {
      path: 'withdrawDetails/:id',
      name: 'WithdrawDetails',
      component: () => import('@/views/wallet/details'),
      meta: { title: '结算详情', noCache: true }
    }
  ]
};

export default WalletRouter;